'use client';

import Markdown from 'react-markdown';

import { cn } from 'utils/cn';

import styles from './styles.module.css';

interface LegalDocumentProps {
	content: string;
	lastUpdate: Date;
}

function LegalDocument(props: LegalDocumentProps) {
	return (
		<div className={cn('content', styles.container)}>
			<small>
				Ultima atualização em{' '}
				<span>
					{new Date().toLocaleString('pt-BR', {
						day: 'numeric',
						month: 'long',
						year: 'numeric',
						hour: 'numeric',
						minute: 'numeric',
					})}
				</span>
			</small>
			<Markdown>{props.content}</Markdown>
		</div>
	);
}

export default LegalDocument;
